
import React from 'react';
import { motion } from 'framer-motion';
import { useIntersectionObserver } from '../../hooks/useIntersectionObserver';
import { fadeInUp } from '../../utils/animations';
import './LeapPreview.css';

const LeapPreview = () => {
    const [ref, isVisible] = useIntersectionObserver();

    return (
        <section className="leap-preview-section section" ref={ref}>
            <div className="container">
                <motion.div
                    initial="initial"
                    animate={isVisible ? "animate" : "initial"}
                    variants={fadeInUp}
                    className="differentiation-main-title-wrapper"
                    style={{ textAlign: 'center' }}
                >
                    <h3 className="differentiation-title">What Makes Triology Different</h3>
                </motion.div>

                <div className="differentiation-grid">
                    <motion.div
                        className="differentiation-left"
                        initial={{ opacity: 0, x: -50 }}
                        animate={isVisible ? { opacity: 1, x: 0 } : { opacity: 0, x: -50 }}
                        transition={{ duration: 0.6 }}
                    >
                        <h4 className="differentiation-subtitle">
                            We don’t assume. We diagnose.
                        </h4>
                        <div className="differentiation-text-block">
                            <p>
                                Triology is a management and digital consulting firm that works at the intersection of <span className="highlight">clarity, systems, and execution.</span>
                            </p>
                            <p>
                                At Triology, we act as a catalyst accelerating organizational evolution while ensuring ownership remains within leadership and teams.
                            </p>
                            <p>
                                Our engagements begin with understanding the organization as a system not jumping to solutions.
                            </p>
                        </div>
                    </motion.div>

                    <motion.div
                        className="differentiation-right"
                        initial={{ opacity: 0, x: 50 }}
                        animate={isVisible ? { opacity: 1, x: 0 } : { opacity: 0, x: 50 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                    >
                        <div className="differentiation-list-wrapper">
                            <p className="list-intro">We help organizations:</p>
                            <ul className="differentiation-list">
                                <li>
                                    <span className="bullet-point"></span>
                                    see the real problem clearly
                                </li>
                                <li>
                                    <span className="bullet-point"></span>
                                    design systems that fit their context
                                </li>
                                <li>
                                    <span className="bullet-point"></span>
                                    execute with discipline and ownership
                                </li>
                            </ul>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
};

export default LeapPreview;
